<template>
    <div>
        <div class="weChat_warning" v-if="weChatWarningShow">
			<h4>请在微信或支付宝中打开</h4>
		</div>
    </div>
</template>

<script>
import { http_getPayUrl,http_saveCrmSelfPoint } from '@/request/crm';

    export default {
        data() {
            return {
                weChatWarningShow:false
            }
        },
        mounted(){
            this.isDev=this.$base.isDev()
            this.env = this.$base.getEnv();
				// 如果是正式环境并且不是用支付宝/微信打开
			if (this.isDev && !this.env) {
					this.weChatWarningShow = true;
			} else {
					this.weChatWarningShow = false;
					this.getPay()
			}
        },
        methods: {
           async getPay() {
                const id=this.$route.query.id
                const res=await http_getPayUrl(id)
                await http_saveCrmSelfPoint({quotationId:id,type:1,pointUrl:res})
                window.location.href=res
            }
        },
    }
</script>

<style lang="scss" scoped>
.weChat_warning {
	font-size: 0.4rem;
	text-align: center;
}
</style>